import React from 'react';
import { Box, IconProps } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

export interface IconArtworkProps {
    icon: React.ComponentType<IconProps>;
}

const iconWrapperStyles = css({
    position: 'relative',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    padding: '18%',
    backgroundColor: 'surface.medium',

    '& svg': {
        verticalAlign: 'middle',
        minWidth: '100%',
        minHeight: '100%',
        color: 'icon.low',

        '& > path, & circle': {
            strokeWidth: '1%',
        },

        '& g path, & g circle': {
            strokeWidth: '1%',
        },
    },
});

const IconArtwork: React.FC<IconArtworkProps> = ({ icon }) => {
    const Icon = icon;

    return (
        <Box className={iconWrapperStyles}>
            <Icon />
        </Box>
    );
};

IconArtwork.displayName = 'IconArtwork';

export default IconArtwork;
